import React from 'react'
import ReactDom from 'react-dom'
import { ChartsProps, Charts } from './Charts'
import { createDivOutside } from './utils/element/createDivOutside'

export async function RenderCharts(chartProps: ChartsProps): Promise<HTMLDivElement> {
    return await new Promise(resolve => {        
        const contentContent = createDivOutside()
        document.body.append(contentContent)
        ReactDom.render(<Charts {...chartProps} onLoadQueries={() => resolve(contentContent)} />, contentContent)
    })
}
